import React, { useState } from 'react';
import { payrollAPI } from '../services/api';
import { useNavigate } from 'react-router-dom';

const AddPayroll: React.FC = () => {
  const [employeeId, setEmployeeId] = useState('');
  const [associates, setAssociates] = useState<{ _id: string; name: string }[]>([]);
  const [month, setMonth] = useState('');
  const [salary, setSalary] = useState('');
  const [status, setStatus] = useState('pending');
  const [paidDate, setPaidDate] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    // Fetch all associates for dropdown
    import('../services/api').then(({ associateAPI }) => {
      associateAPI.getAllAssociates()
        .then((res) => {
          // Filter associates with valid _id and name
          const filtered = (res.data as { _id?: string; name?: string }[])
            .filter(a => a._id && a.name)
            .map(a => ({ _id: a._id as string, name: a.name as string }));
          setAssociates(filtered);
        })
        .catch(() => setAssociates([]));
    });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await payrollAPI.create({ employeeId, month, salary: Number(salary), status, paidDate });
      setMessage('Payroll added successfully!');
      setEmployeeId('');
      setMonth('');
      setSalary('');
      setStatus('pending');
      setPaidDate('');
    } catch (err) {
      setMessage('Failed to add payroll.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-8 bg-white rounded shadow mt-8">
      <h2 className="text-xl font-bold mb-6">Add Payroll</h2>
              {message && <div className="mt-2 text-center text-green-600">{message}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Employee</label>
          <select
            value={employeeId}
            onChange={e => setEmployeeId(e.target.value)}
            className="w-full border rounded px-3 py-2"
            required
          >
            <option value="">Select Associate</option>
            {associates.map(a => (
              <option key={a._id} value={a._id}>{a.name} ({a._id})</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Month</label>
          <input type="month" value={month} onChange={e => setMonth(e.target.value)} className="w-full border rounded px-3 py-2" required />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Salary</label>
          <input type="number" value={salary} onChange={e => setSalary(e.target.value)} className="w-full border rounded px-3 py-2" required />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Status</label>
          <select value={status} onChange={e => setStatus(e.target.value)} className="w-full border rounded px-3 py-2">
            <option value="Pending">Pending</option>
            <option value="Paid">Paid</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Paid Date</label>
          <input type="date" value={paidDate} onChange={e => setPaidDate(e.target.value)} className="w-full border rounded px-3 py-2" />
        </div>
        {/* <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 transition" disabled={loading}>
          {loading ? 'Adding...' : 'Add Payroll'}
        </button> */}
        {/* {message && <div className="mt-2 text-center text-green-600">{message}</div>} */}
        <div className="flex justify-between mt-4">
          <button
            type="button"
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded shadow hover:bg-gray-400 transition"
            onClick={() => navigate('/finance', { state: { tab: 'payroll' } })}
          >
             Back
          </button>
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 transition" disabled={loading}>
            {loading ? 'Adding...' : 'Add Payroll'}
          </button>
        </div>
        {/* {message && <div className="mt-2 text-center text-green-600">{message}</div>} */}
      </form>
    </div>
  );
};

export default AddPayroll;
